import React, { useState } from 'react';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import { ordenanzas } from '@/api/gobiernoAbiertoApi';
import { sendSolicitudDecreto } from '@/api/municipalidadAPI';
import Joi from 'joi';
import ValidationHelper from '@/helpers/validationHelper';
import MunicipalidadHeader from '../components/Header/MunicipalidadHeader';
import Loader from '../components/Loader/Loader';
import './DecretosView.css';

const HomeView = () => {
  const [consulta, setConsulta] = useState({
    nombre: '',
    dni: '',
    email: '',
    decreto: '',
    ordenanza: '',
    aclaraciones: '',
  });
  const [consultaRealizada, setConsultaRealizada] = useState({
    nombreEnviado: '',
    emailEnviado: '',
  });
  const [loading, setLoading] = useState();
  const { nombre, dni, email, decreto, ordenanza, aclaraciones } = consulta;
  const { nombreEnviado, emailEnviado } = consultaRealizada;

  const decretosSchema = Joi.object({
    nombre: Joi.string().required().messages({
      'string.base': 'El campo nombre es obligatorio',
      'any.required': 'El campo nombre es obligatorio',
      'string.empty': 'El campo nombre es obligatorio',
    }),
    dni: Joi.string().required().messages({
      'string.base': 'El campo dni es obligatorio',
      'any.required': 'El campo dni es obligatorio',
      'string.empty': 'El campo dni es obligatorio',
    }),
    email: Joi.string().required().messages({
      'string.base': 'El campo email es obligatorio',
      'any.required': 'El campo email es obligatorio',
      'string.empty': 'El campo email es obligatorio',
    }),
    decreto: Joi.string().required().messages({
      'string.base': 'El campo decreto es obligatorio',
      'any.required': 'El campo decreto es obligatorio',
      'string.empty': 'El campo decreto es obligatorio',
    }),
  });

  const filterOrdenanzas = (inputValue, callback) => {
    let request = {
      estado: '-1',
      numero: '',
      anio: '',
      pattern: inputValue,
    };
    if (inputValue.length < 3) {
      return [];
    }
    ordenanzas(request)
      .then((response) => {
        const result = JSON.parse(response.data);
        let options = new Array();
        for (let i = 0; i < result.length; i++) {
          if (result[i].Expediente) {
            options.push({
              value: result[i].ID,
              id: result[i].ID,
              label:
                'Ordenanza ' +
                result[i].Numero +
                ' ' +
                getEstado(result[i].Estado) +
                ' ' +
                result[i].Expediente,
            });
          }
        }
        callback(options);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadOptions = (inputValue, callback) => {
    filterOrdenanzas(inputValue, callback);
  };

  const estados = [
    { value: '1', label: 'Clasificando' },
    { value: '2', label: 'Aprobada/Vigente' },
    { value: '3', label: 'Derogada' },
    { value: '4', label: 'Vetada' },
    { value: '9', label: 'Anulada' },
  ];

  const getEstado = (valor) => {
    return estados.filter((i) => i.value == valor)[0].label;
  };

  const onChange = (_event) => {
    setErrors({ ...errors, [_event.currentTarget.id]: null });
    setConsulta({ ...consulta, [_event.currentTarget.id]: _event.currentTarget.value });
  };

  const onChangeSelect = (_event) => {
    setErrors({ ...errors, ['ordenanza']: null });
    setConsulta({ ...consulta, ['ordenanza']: _event.id });
  };

  const [errors, setErrors] = useState({
    nombre: null,
    dni: null,
    email: null,
    decreto: null,
    ordenanza: null,
    aclaraciones: null,
  });

  const onEnviar = () => {
    ValidationHelper.validateSchema(decretosSchema, consulta)
      .then(() => {
        let request = {
          nombre: nombre,
          dni: dni,
          email: email,
          numero: decreto,
          ordenanza: ordenanza,
          aclaraciones: aclaraciones,
        };
        setLoading(true);
        sendSolicitudDecreto(request)
          .then((response) => {
            console.log(response);
            setConsultaRealizada({ nombreEnviado: nombre, emailEnviado: email });
            setConsulta({
              nombre: '',
              dni: '',
              email: '',
              decreto: '',
              ordenanza: '',
              aclaraciones: '',
            });
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
      })
      .catch((schemaErrors) => {
        console.log('errrres');
        setErrors(schemaErrors);
      });
  };

  return (
    <>
      <MunicipalidadHeader tipo="Ciudadano" title="Solicitud de Decretos"></MunicipalidadHeader>
      <Container className="content pagina-interna">
        <Loader loading={loading}></Loader>
        {nombreEnviado != '' && (
          <Alert key={'success'} variant={'success'}>
            <div>
              Listo <b>{nombreEnviado}</b>
            </div>
            <div>
              Estamos procesando su solicitud. Si todo está bien enviaremos el documento solicitado
              a su cuenta de correo electrónico <b>{emailEnviado}</b> Lo más rápido posible.
            </div>
          </Alert>
        )}
        <Form>
          <div className="dimmer"></div>
          <Form.Group className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              id="nombre"
              onChange={onChange}
              value={nombre}
              error={errors.nombre}
            />
            {errors.nombre && <div className="text-danger">{errors.nombre}</div>}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>DNI</Form.Label>
            <Form.Control type="text" placeholder="" id="dni" onChange={onChange} value={dni} />
            {errors.dni && <div className="text-danger">{errors.dni}</div>}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control type="text" placeholder="" id="email" onChange={onChange} value={email} />
            {errors.email && <div className="text-danger">{errors.email}</div>}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Número de Decreto</Form.Label>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                placeholder=""
                id="decreto"
                onChange={onChange}
                value={decreto}
              />
              {errors.decreto && <div className="text-danger">{errors.decreto}</div>}
            </Form.Group>
          </Form.Group>
          <Form.Group className="mb-3">
            <AsyncSelect loadOptions={loadOptions} onChange={onChangeSelect} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Aclaraciones</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder=""
              id="aclaraciones"
              onChange={onChange}
              value={aclaraciones}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Button className="buscar" onClick={onEnviar} variant="primary">
              Enviar
            </Button>
          </Form.Group>
        </Form>
      </Container>
    </>
  );
};

export default React.memo(HomeView);
